import Dexie from 'dexie';

const dbSw = new Dexie('workbox-background-sync');

Dexie.exists("workbox-background-sync").then(function(exists) {
    if (!exists){
        console.info("Database 'workbox-background-sync' doesn't exist");
        return;
    }

    dbSw.open().then(function () {
        let schema = {};

        dbSw.tables.forEach(function (table) {
            var primKeyAndIndexes = [table.schema.primKey].concat(table.schema.indexes);
            var schemaSyntax = primKeyAndIndexes.map(function (index) { return index.src; }).join(',');
            schema[table.name] = schemaSyntax;
        });

        dbSw.close();

        return schema;
    }).then((schema) => {
        dbSw.version(dbSw.verno).stores(schema);
        dbSw.open();
    })
}).catch(function (error) {
    console.error("Oops, an error occurred when trying to check database existance", error);
});


export default dbSw
